import React from "react";
import {useLocation} from "react-router-dom";
import {AuthPageLayout} from "../../components/AuthShell";
import ResendVerificationForm from "./ResendVerificationForm";
import {
  BodyText,
  Heading,
  StatePanel,
} from "./styled";

export default function ResendVerification() {
  const location = useLocation();

  return (
    <AuthPageLayout testId="verify-email-resend">
      <StatePanel>
        <Heading component="h1">Request a new verification email</Heading>
        <BodyText>
          Enter your email address. For privacy, we give the same response whether or not an account exists.
        </BodyText>
        <ResendVerificationForm initialEmail={location.state?.email || ""} />
      </StatePanel>
    </AuthPageLayout>
  );
}
